import  VerTickets  from './HistorialTickets';
export default VerTickets;
